import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import { MotifIconModule, MotifTooltipModule } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-tb-agent-summary',
  standalone: true,
  imports: [MotifIconModule, MotifTooltipModule, CommonModule],
  templateUrl: './tb-agent-summary.component.html',
  styleUrl: './tb-agent-summary.component.scss',
})
export class TbAgentSummaryComponent implements AfterViewInit {
  IconoirInfoCircle = IconoirInfoCircle;
  hoverableRecordsCleansed: string =
    'A cleansed file is a processed version of the original trial balance, where formatting inconsistencies, errors, or unnecessary data have been removed to ensure accurate extraction and analysis.';
  hoverableRecordsRemoved: string =
    'Records may have been removed based on the following rules: records where both Account Code and Account Description are empty, records with empty Account Codes, records with invalid Account Codes (e.g., IP-like values), and sub-total/total rows';

  // view children
  @ViewChild('recordsRemovedTooltipTemplate')
  recordsRemovedTooltipTemplate!: TemplateRef<any>;
  @ViewChild('recordsCleansedTooltipTemplate')
  recordsCleansedTooltipTemplate!: TemplateRef<any>;

  //references
  recordsCleansedTooltipTemplateRef!: TemplateRef<any>;
  recordsRemovedTooltipTemplateRef!: TemplateRef<any>;

  private _cleansingSummary!: any;

  @Input()
  set cleansingSummary(value: any) {
    this._cleansingSummary = value;
  }

  get cleansingSummary(): any {
    return this._cleansingSummary;
  }

  constructor() {}

  ngAfterViewInit(): void {
    // Assign the template after view has initialized
    this.recordsCleansedTooltipTemplateRef =
      this.recordsCleansedTooltipTemplate;
    this.recordsRemovedTooltipTemplateRef = this.recordsRemovedTooltipTemplate;
  }

  showTooltipOnEnter(event: KeyboardEvent | Event) {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
      activeElement.click();
    }
  }
}
